import React from 'react';
import { Field } from 'react-final-form';

/**
 * RFF replacement for redux-form's <Fields>.
 * Builds up a single "fields"-like props object:
 *   fields[names[i]] -> { input, meta }
 *   fields.names -> original names array
 */
const RffFields = ({ names, component: Comp, ...rest }) => {
  const renderAt = (i, acc) => {
    if (i >= names.length) {
      return <Comp {...acc} />;
    }
    const name = names[i];
    return (
      <Field
        name={name}
        subscription={{ value: true, touched: true, error: true }}
      >
        {({ input, meta }) =>
          renderAt(i + 1, {
            ...acc,
            [name]: { input, meta },
            names,
          })
        }
      </Field>
    );
  };
  return renderAt(0, { ...rest });
};

export default RffFields;
